module.exports = __webpack_public_path__ + "static/media/TermsConditions_NL.c9be3530.pdf";